import Vue from 'vue'
import Router from 'vue-router'

const routerOptions = [
  { path: '/', redirect: 'home' },
  { path: '/login', name: 'login', componentName: 'Login', meta: { protected: false } },
  { path: '/home', name: 'Home', componentName: 'Home', meta: { protected: true } },
  { path: '/admin', name: 'Admin', componentName: 'Admin', meta: { protected: true } },
  { path: '/restaurants/:restaurantId/services', name: 'services', componentName: 'Services', meta: { protected: true } },
  { path: '/restaurants/:restaurantId/sections/:sectionId/services', name: 'sectionServices', componentName: 'Services', meta: { protected: true } },
  { path: '/restaurants/:restaurantId/sections/:sectionId/services/:serviceId', name: 'sectionService', componentName: 'Services', meta: { protected: true } },
  { path: '/restaurants/:restaurantId/sections/:sectionId/services/:serviceId/:tab', name: 'sectionServiceTab', componentName: 'Services', meta: { protected: true } },

  { path: '/restaurants/:restaurantId/orders', name: 'orders', componentName: 'Orders', meta: { protected: true } },
  { path: '/restaurants/:restaurantId/sections/:sectionId/orders', name: 'sectionOrders', componentName: 'Orders', meta: { protected: true } },
  { path: '/restaurants/:restaurantId/counters/:counterId/orders', name: 'counterOrders', componentName: 'Orders', meta: { protected: true } },

  { path: '/restaurants/:restaurantId/inventory', name: 'inventory', componentName: 'Inventory', meta: { protected: true } },
  { path: '/restaurants/:restaurantId/counters/:counterId/inventory', name: 'counterInventory', componentName: 'Inventory', meta: { protected: true } },

  { path: '/restaurants/:restaurantId/reports', name: 'reports', componentName: 'Reports', meta: { protected: true } },
  { path: '/restaurants/:restaurantId/sections/:sectionId/reports', name: 'sectionReports', componentName: 'Reports', meta: { protected: true } },
  { path: '/restaurants/:restaurantId/sections/:sectionId/reports/:reportId', name: 'sectionReport', componentName: 'Reports', meta: { protected: true } },
  { path: '/restaurants/:restaurantId/counters/:counterId/reports', name: 'counterReports', componentName: 'Reports', meta: { protected: true } },
  { path: '/restaurants/:restaurantId/counters/:counterId/reports/:reportId', name: 'counterReport', componentName: 'Reports', meta: { protected: true } },
  { path: '/restaurants/:restaurantId/reports/:reportId', name: 'restaurantReport', componentName: 'Reports', meta: { protected: true } },

  { path: '*', redirect: 'login' }
]

const routes = routerOptions.map(route => {
  return {
    ...route,
    component: () => import(`@/views/${route.componentName}.vue`)
  }
})

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes
})